var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DemoBase',[_c('Modal',{attrs:{"persistent":"","title":"Example Title","has-form":true,"show":_vm.dialog,"overlay":false,"class-object":['pa-4']},on:{"onClose":_vm.closePopup}},[_c('Button',{attrs:{"title":"Hello"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }